import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'

type TabProps = {
  currentTab: 'summary' | 'answers'
}

export const SurveyTab: React.FC<TabProps> = ({ currentTab }) => {
  const history = useHistory()
  const location = useLocation()
  const { t } = useTranslation()

  return (
    <div css={tabContainerStyle}>
      <div
        css={currentTab === 'summary' ? tabActiveStyle : tabStyle}
        onClick={() => history.push({ pathname: '/survey/summary', search: location.search })}
      >
        {t('Aggregate')}
      </div>
      <div
        css={currentTab === 'answers' ? tabActiveStyle : tabStyle}
        onClick={() => history.push({ pathname: '/survey/answers', search: location.search })}
      >
        {t('Answer List')}
      </div>
    </div>
  )
}

const centerStyle = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

const tabContainerStyle = css({
  height: 45,
  display: 'flex',
})

const tabStyle = css(centerStyle, {
  width: 134,
  height: 45,
  borderRadius: '5px 5px 0 0',
  background: '#F5F5F5',
  boxShadow: '0px 0px 6px #0000001A',
  fontSize: 14,
  fontWeight: 'bold',
  color: '#676767',
  '&:hover': {
    cursor: 'pointer',
    opacity: 0.8,
  },
})

const tabActiveStyle = css(centerStyle, {
  width: 134,
  height: 41,
  borderRadius: '5px 5px 0 0',
  background: '#fff',
  boxShadow: '0px 0px 6px #0000001A',
  position: 'relative',
  fontSize: 14,
  fontWeight: 'bold',
  color: '#F2A40B',
  '&::after': {
    position: 'absolute',
    bottom: -4,
    left: 0,
    height: 6,
    width: '100%',
    content: '""',
    background: '#fff',
    zIndex: 3,
  },
})
